import { Http } from "../axios/interceptors";

export const allPermissions = async (param) =>
  Http("GET", `/Permissions/GetList?`, param);

export const createOrEditPermission = async (body, id = null) =>
  id
    ? Http("PUT", `/Permissions/Update`, null, body)
    : Http("POST", "/Permissions/Create", null, body);

export const permissionDelete = async (idPermission) =>
  Http("DELETE", `/Permissions/Delete?idPermission=${idPermission}`);

export const copyPermission = async (body, id = null) =>
  Http("POST", "/Permissions/Copy", null, body);
